import * as React from "react"
import { Link } from "gatsby"
import Button from "../Button/Button"
import { BasicTextModuleStyles } from "./BasicTextModuleStyles"

const BasicTextModule = ({ eyebrow, title, content, link, linkText }) => {
  return (
    <>
      <div id="content-section" />
      <BasicTextModuleStyles className="section">
        <div className="container container__tight">
          <div className="basic__inner">
            {eyebrow && <p className="eyebrow">{eyebrow}</p>}
            {title && <h2>{title}</h2>}
            {content && <p className="lead">{content}</p>}
            {link && linkText && (
              <div className="learn__more">
                <Button as={Link} to={link} text={linkText} arrow />
              </div>
            )}
          </div>
        </div>
      </BasicTextModuleStyles>
    </>
  )
}

export default BasicTextModule
